import {
	CompanyNode,
	OtherNode,
	PartnershipNode,
	TrustNode,
} from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/Nodes';
import { DebtEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/Edges';
import { Edge, Node } from '@dealstack/shared/lib/generated';
import { Position, StepEdge } from '@xyflow/react';
import { SmartStepEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartStepEdge/SmartStepEdge';

export enum NodeTypes {
	PARTNERSHIP = 'partnership',
	COMPANY = 'company',
	OTHER = 'other',
	TRUST = 'trust',
}

export enum EdgeTypes {
	EQUITY = 'equity',
	DEBT = 'debt',
}

export const nodeTypes = {
	[NodeTypes.PARTNERSHIP]: PartnershipNode,
	[NodeTypes.COMPANY]: CompanyNode,
	[NodeTypes.OTHER]: OtherNode,
	[NodeTypes.TRUST]: TrustNode,
};

export const edgeTypes = {
	[EdgeTypes.DEBT]: DebtEdge,
	[EdgeTypes.EQUITY]: SmartStepEdge,
};

export const edgeTypesFast = {
	[EdgeTypes.DEBT]: DebtEdge,
	[EdgeTypes.EQUITY]: StepEdge,
};

export type NodeLoanData = {
	source: boolean;
	target: boolean;
	sourcePosition?: Position | null;
};

/**
 * Chrome the Review step overlays on a node, where the chart previews what a batch's merge would do. Undefined on
 * the cap chart page, which draws exactly as it did.
 */
export type NodeReview = {
	/** Role pill beside the registration badges, e.g. "Target". */
	tag?: string;
	/** Spells the pill out where it is an abbreviation, e.g. "New" for "New company, creates on merge". */
	tagTooltip?: string;
	/** The merge creates this company, so it is drawn dashed. */
	isNew?: boolean;
	/** Set when the merge would take a holding here below zero; the text labels the warning marker. */
	conflictLabel?: string;
};

export type NodeData = {
	label: string;
	registeredId?: string;
	isMipGroup: boolean;
	registeredName?: string;
	countryCode?: string;
	loanData?: NodeLoanData;
	review?: NodeReview;
};

export type NodeRes = Node;
export type EdgeRes = Edge;
